import styled from 'styled-components';
import { theme } from '@Themes/themeOverriderFabric';

const { white, darkGray, lightGray, azure } = theme.palette;

export const StyledLabel = styled.label({
    fontSize: 13,
    lineHeight: '18px',
    color: darkGray,
    cursor: 'pointer',
    userSelect: 'none'
});

export const StyledContentWrap = styled.div({
    position: 'relative',
    paddingLeft: 28
});

export const StyledRadioButton = styled.input({
    opacity: 0,
    position: 'absolute',
    zIndex: -1,
    appearance: 'none',

    [`& + ${StyledContentWrap}:before`]: {
        content: '""',
        display: 'inline-block',
        position: 'absolute',
        left: 1,
        top: 1,
        width: 18,
        height: 18,
        transition: 'background-color 0.4s, box-shadow 0.4s',
        borderRadius: '50%',
        border: `3px solid ${white}`,
        backgroundColor: white,
        boxShadow: `0px 0px 1px 1px ${lightGray}`
    },
    [`&:checked + ${StyledContentWrap}:before`]: {
        backgroundColor: azure,
        boxShadow: `0px 0px 1px 1px  ${lightGray}`
    },
    [`&:disabled + ${StyledContentWrap}`]: {
        cursor: 'not-allowed',
        opacity: 0.5
    }
});
